import { assert } from '@varos/util-typescript';
export function createReportChapterRepository(config) {
    const { repository, client } = config;
    function toReportChapter(data) {
        assert(data.parent, 'expected report chapter content to have a parent');
        return {
            id: data.id,
            report: data.parent,
            title: data.title ?? 'Untitled',
            caption: data.caption,
            description: data.description,
            ordinal: data.ordinal,
            lastEditedAt: data.last_edited_at,
        };
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['report', 'chapter', 'find', props],
                async queryFn() {
                    const response = await client.user.content.list({
                        parent: props.report,
                    }, {
                        headers: {
                            'x-workspace-id': 'test',
                        },
                    });
                    return response.data
                        .filter((candidate) => candidate.visibility !== 'unlisted')
                        .map(toReportChapter);
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['report', 'chapter', 'lookup', props.id],
                async queryFn() {
                    const response = await client.user.content.retrieve(props.id, {
                        headers: {
                            'x-workspace-id': 'test',
                        },
                    });
                    return toReportChapter(response);
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=reportChapterRepository.js.map